module.exports = __webpack_public_path__ + "img/avatar-12.b860f2b4.png";